import { render, staticRenderFns } from "./BotaoHome.vue?vue&type=template&id=bcc36c56&lang=pug"
import script from "./BotaoHome.vue?vue&type=script&lang=js"
export * from "./BotaoHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports